import { isQuestionItem } from '../../state-type-guards';
import type { AnswerState, StoreState } from '../../state-types';
import { generateAnswerShape } from '../utils/generate-answer-shape';
import { makeSurveyDirty } from '../utils/make-survey-dirty';

/** Add a new answer to a card based on the card type */
export const addAnswer =
    (cardId: string, partialAnswer: Partial<AnswerState> = {}) =>
    (state: StoreState): StoreState => {
        const card = state.actions.getCard(cardId);
        if (!card) {
            throw new Error('Card not found');
        }

        // Ensure it's a question card
        if (!isQuestionItem(card)) {
            throw new Error('Only Question Cards can have Answers.');
        }

        const answer = generateAnswerShape(card.type, partialAnswer);
        if (!answer) {
            return state;
        }

        return makeSurveyDirty({
            ...state,
            cards: {
                ...state.cards,
                [cardId]: {
                    ...card,
                    // update the card's answer list
                    answerIds: card.answerIds.concat(answer.id),
                },
            },
            answers: {
                ...state.answers,
                // add the new answer into the answers collection
                [answer.id]: answer,
            },
        });
    };
